import { ChangeEvent } from 'react';

import Checkbox from '@components/checkbox/Checkbox';

import CustomTableSortableHeader from './CustomTableSortableHeader';
import {
  CustomTableHeaderProps,
  CustomTableSortOrder,
  CustomTableSortState
} from './types';

const getHeaderAlignClass = (align?: CustomTableHeaderProps['align']) =>
  align === 'right' ? 'text-right' : '';

const CustomTableHeader = ({
  headers,
  hasMultiSelect = false,
  handleSelectAll,
  isAllRowSelected,
  isAllRowDisabled,
  enableSort = false,
  sortState = null,
  onSortChange
}: {
  headers: CustomTableHeaderProps[];
  hasMultiSelect?: boolean;
  handleSelectAll?: (checked: boolean) => void;
  isAllRowSelected?: boolean;
  isAllRowDisabled?: boolean;
  enableSort?: boolean;
  sortState?: CustomTableSortState | null;
  onSortChange?: (sortKey: string, sortOrder: CustomTableSortOrder) => void;
}) => (
  <div className="flex h-12.5 items-center justify-between truncate rounded-lg bg-cofeeGreyBlue3 p-4">
    {hasMultiSelect && (
      <div className="w-5">
        <Checkbox
          handleChange={(e: ChangeEvent<HTMLInputElement>) =>
            handleSelectAll?.(e.target.checked)
          }
          isChecked={isAllRowSelected && !isAllRowDisabled}
          disabled={isAllRowDisabled}
          variant="v2"
        />
      </div>
    )}
    {headers.map((header) => (
      <div
        key={header.accessor}
        style={{ width: header.width }}
        className={`px-2 text-sm font-medium text-cofeeNeutral10 ${getHeaderAlignClass(
          header.align
        )}`}
      >
        {enableSort &&
        header.sortable &&
        header.sortKey &&
        onSortChange &&
        typeof header.Header === 'string' ? (
          <CustomTableSortableHeader
            label={header.Header}
            sortKey={header.sortKey}
            sortState={sortState}
            onSortChange={onSortChange}
          />
        ) : (
          header.Header
        )}
      </div>
    ))}
  </div>
);

export default CustomTableHeader;
